document.addEventListener('DOMContentLoaded', e => {
  const scrollContainerSelector = '[data-cta-scroll-container]';
  const scrollCtaSelector = '[data-cta-scroll]';
  const scrollCtaContainerEls = Array.from(document.querySelectorAll(scrollContainerSelector));
  let start, previousTimeStamp;
  let done = false;

  // Check if shop is opened from instagram browser on ios device
  const stickyTitleEnabled = !(navigator.userAgent.indexOf("Instagram") != -1 && navigator.userAgent.indexOf("iOS") != -1)

  /**
   * @typedef {Object} ContainerState
   * @property {number} containerWidth - The width of the container, in pixels
   * @property {number} containerDistanceFromLeft - The distance from the left of the viewport, in pixels
   * @property {number} spacing - The distance from the left of the viewport, in pixels
   */

  /**
   *
   * @param {HTMLElement} containerEl - The main container
   *
   * @returns {ContainerState}
   */
  const getContainerState = (containerEl) => {
    const spacing = JSON.parse(containerEl.dataset.ctaScrollSpacing);
    let useSpacing;

    if (matchMedia('(max-width: 767px)').matches) {
      useSpacing = spacing.mobile;
    } else {
      useSpacing = spacing.desktop;
    }

    return {
      containerWidth: containerEl.getBoundingClientRect().width,
      containerDistanceFromLeft: containerEl.getBoundingClientRect().x,
      spacing: useSpacing,
    }
  };

  /**
   *
   * @param {HTMLElement} scrollCtaEl - The element that moves with scrolling
   * @param {ContainerState} containerState
   */
  const setCtaState = (scrollCtaEl, containerState = {}) => {
    const { spacing, containerWidth, containerDistanceFromLeft } = containerState;
    const width = containerWidth - spacing * 2;
    const distanceFromLeft = containerDistanceFromLeft + spacing;

    scrollCtaEl.style.width = `${width}px`;
    scrollCtaEl.style.setProperty('--spacing', `${spacing}px`);
    scrollCtaEl.style.setProperty('--distance-from-left', `${distanceFromLeft}px`);
  }

  scrollCtaContainerEls.forEach(containerEl => {
    const { containerWidth, containerDistanceFromLeft, spacing } = getContainerState(containerEl);
    const scrollCtaEl = containerEl.querySelector(scrollCtaSelector);

    setCtaState(scrollCtaEl, {
      containerWidth,
      containerDistanceFromLeft,
      spacing
    });
  });

  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const containerEl = entry.target;
      const { containerWidth, containerDistanceFromLeft, spacing } = getContainerState(containerEl);
      const scrollCtaEl = containerEl.querySelector(scrollCtaSelector);

      setCtaState(scrollCtaEl, {
        containerWidth,
        containerDistanceFromLeft,
        spacing
      });

      positionCta(containerEl);
    }
  });

  scrollCtaContainerEls.forEach(containerEl => resizeObserver.observe(containerEl));

  const positionCta = (scrollCtaContainer) => {
    const clientRect = scrollCtaContainer.getBoundingClientRect();
    const cta = scrollCtaContainer.querySelector(scrollCtaSelector);

    if (cta && stickyTitleEnabled) {
      const ctaClientRect = cta.getBoundingClientRect();
      const spacing = parseInt(cta.style.getPropertyValue('--spacing').replace('px', ''));
      const distanceFromLeft = parseInt(cta.style.getPropertyValue('--distance-from-left').replace('px', ''));
      const translateY = window.innerHeight - clientRect.y - clientRect.height;

      if (translateY > 0 || clientRect.y > window.innerHeight) {
        // Bottom border
        cta.style.position = 'absolute';
        cta.style.top = 'unset';
        cta.style.bottom = `${spacing}px`;
        cta.style.left = null;
      } else if (clientRect.y + ctaClientRect.height + spacing * 2 > window.innerHeight) {
        // Top border
        cta.style.position = 'absolute';
        cta.style.top =  `${spacing}px`;
        cta.style.bottom = 'unset';
        cta.style.left = null;
      } else {
        // Moving
        cta.style.position = 'fixed';
        cta.style.top = 'unset';
        cta.style.bottom = `${spacing}px`;
        cta.style.left = `${distanceFromLeft}px`;
      }
    }
  }

  function step(timeStamp) {
    if (start === undefined) {
      start = timeStamp;
    }
    const elapsed = timeStamp - start;
    if (previousTimeStamp !== timeStamp) {
      const count = Math.min(0.1 * elapsed, 200);
      scrollCtaContainerEls.forEach(scrollCtaContainer => positionCta(scrollCtaContainer));
      if (count === 200) done = true;
    }
    if (elapsed < 2000) {
      previousTimeStamp = timeStamp;
      if (!done) {
        window.requestAnimationFrame(step);
      }
    }
  }

  document.addEventListener('scroll', () => window.requestAnimationFrame(step));
  window.requestAnimationFrame(step);
});
